const { toFirstLowerCase } = require('utilities/stringHelper');

/**
 * Works on arrays as well as objects.
 **/
const keysToCamelCase = (object) => {
    let result = {};
    for (const key in object) {
        const value = object[key];
        if (value.constructor === Object) {
            result[toFirstLowerCase(key)] = keysToCamelCase(value);
        } else if (value.constructor === Array) {
            if (key === "DocumentTypes") {
                result[toFirstLowerCase(key)] = value;
            } else {
                result[toFirstLowerCase(key)] = value.map(v => keysToCamelCase(v));
            }
        } else {
            result[toFirstLowerCase(key)] = value;
        }
    }
    return result;
};


module.exports = keysToCamelCase;
